module.exports = __webpack_public_path__ + "img/hasbind.dfad23bf.png";